import { render, staticRenderFns } from "./Saledorderinfo.vue?vue&type=template&id=3a77a3c8&scoped=true&"
import script from "./Saledorderinfo.vue?vue&type=script&lang=js&"
export * from "./Saledorderinfo.vue?vue&type=script&lang=js&"
import style0 from "./Saledorderinfo.vue?vue&type=style&index=0&id=3a77a3c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a77a3c8",
  null
  
)

export default component.exports